import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appSticky]',
})
export class StickyDirective {
    private headerHeight = 112;

    constructor(private eleRef: ElementRef) {}

    @HostListener('window:scroll', ['$event']) public onWindowScroll(e: any): void {
        const result: number = e.target.scrollingElement.scrollTop;

        if (result > this.headerHeight && !this.eleRef.nativeElement.classList.contains('fixed-buttons')) {
            this.setElementLeft(this.eleRef.nativeElement);
            this.eleRef.nativeElement.classList.add('fixed-buttons');
        } else if (result <= this.headerHeight && this.eleRef.nativeElement.classList.contains('fixed-buttons')) {
            this.resetElementLeft(this.eleRef.nativeElement);
            this.eleRef.nativeElement.classList.remove('fixed-buttons');
        }
    }
    @HostListener('window:resize') public onWindowResize(): void {
        this.setElementLeft(this.eleRef.nativeElement);
    }

    private setElementLeft(elem: HTMLElement): void {
        const item: Element = document.querySelector('.main-wrapper .container-fluid>.row>.col-lg-8');
        const isMobile: boolean = window.innerWidth <= 768;
        elem.style.left = item.scrollWidth + item.scrollLeft + (isMobile ? -26 : 274) + 'px';
    }

    private resetElementLeft(elem: HTMLElement): void {
        elem.style.left = null;
    }
}
